import styled from 'styled-components';

import theme from '../../assets/theme';
import { zIndexes } from '../../utils/zIndexes';

export const DesignerTopBarContainer = styled.div`
  height: 60px;
  width: 100%;
  background: ${theme.colors.creatorTopbarGradient};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12);
  z-index: ${zIndexes('CREATOR_TOP_BAR')};
`;
